// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3BiwW","empty":"ModalGraph_empty__3eS42"};